import React  from 'react';
import {  Checkbox } from 'antd';

export type JCheckboxProps = {
  /**
   * Action to update external module
   * @param value
   */
  onChange?: (value: any) => void;

  /**
   * nameInput
   */
  nameInput?: string;

  /**
   * label
   */
  label?: string;

  /**
   * checked
   */
  checked?: boolean;

  /**
   * disabled
   */
  disabled?: boolean;

};


export const JCheckbox = ({nameInput, label = '', disabled = false, onChange, checked = false}: JCheckboxProps ) => {


  return (
      <Checkbox
            name={nameInput}
            disabled={disabled}
            checked={checked}
            onChange={(e) =>onChange ? onChange(e) : ""}>{label}</Checkbox>
  );
};
